import * as React from 'react'
import { ReactElement } from 'react'
import TaskForm from '../../components/Form/Task/TaskForm'
import EditEntityForm from '../../components/Form/EditEntityForm'
import { TaskAction, TaskMutationDto } from '../../config/taskConfig'
import { EntityFormPage } from '../../components/Form/Form'
import useAxios from '../../hooks/useAxios'

export default function EditTask(props: EntityFormPage): ReactElement {
    const axios = useAxios()
    return (
        <EditEntityForm<TaskMutationDto, TaskMutationDto>
            {...props}
            form={TaskForm}
            getEntity={(id: string) => ({ url: `/task/${id}`, method: 'GET' })}
            updateEntity={(id, values) => ({
                type: TaskAction.Update,
                payload: axios.put(`/task/${id}`, values),
            })}
            getLockedDelete={entity => entity.workflowStepName !== null}
            deleteEntity={id => ({
                type: TaskAction.Delete,
                payload: axios.delete(`/task/${id}`),
            })}
        />
    )
}
